import React, { useMemo } from "react";
import { Modal, Tag, Button, Space } from "antd";
import OrderDTO from "@/dto/order/OrderDTO";
import { PrintCheckResult } from "../types";
import { InjectBaseModalProps } from "@/hooks/Modal/ModalStore";
import { InfoCircleFilled } from "@ant-design/icons";

interface PrintRuleModalProps extends InjectBaseModalProps {
    result: PrintCheckResult;
    onSelectPrintOrders(orders: OrderDTO[]): void;
    onCancel(): void;
}

const PrintRuleModal: React.FC<PrintRuleModalProps> = (props) => {
    const { result, onSelectPrintOrders, onCancel, open } = props;

    const safeOrders = useMemo(
        () =>
            result.totalOrders.filter(
                (order) => !result.forbiddenOrderIds.has(order.id) && !result.orderToOptionalRules.has(order.id),
            ),
        [result],
    );

    const printableOrders = useMemo(
        () => result.totalOrders.filter((order) => !result.forbiddenOrderIds.has(order.id)),
        [result],
    );

    return (
        <Modal
            open={open}
            className="print-check-modal"
            styles={{ body: { padding: "4px 32px 16px" } }}
            title={
                <div className="fb" style={{ display: "flex" }}>
                    <InfoCircleFilled style={{ color: "#faad14", marginTop: "3px" }} className="mr10" />
                    您选择的订单包含{result.optional.map((item) => item.rule.label).join("，")}
                </div>
            }
            footer={null}
            onCancel={onCancel}
            closable={false}
            width={450}
        >
            <p className="error fb" style={{ padding: "5px 20px" }}>
                请谨慎处理，是否继续打印{safeOrders.length ? "或排除后打印" : ""}
            </p>
            <div style={{ display: "flex", justifyContent: "flex-end", padding: "10px 2px 0 0" }}>
                <Button onClick={onCancel} style={{ marginRight: 12 }}>
                    取消
                </Button>
                {safeOrders.length ? (
                    <Button
                        type="primary"
                        style={{ marginRight: 12 }}
                        onClick={() => {
                            onSelectPrintOrders(safeOrders);
                            onCancel();
                        }}
                    >
                        排除后打印
                    </Button>
                ) : null}

                <Button
                    type="primary"
                    onClick={() => {
                        onSelectPrintOrders(printableOrders);
                        onCancel();
                    }}
                    disabled={!printableOrders.length}
                >
                    继续
                </Button>
            </div>
        </Modal>
    );
};

export default PrintRuleModal;
